// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = '4f6f5804778d7c670568b9a6ccdfaeedd3f531f1';
/* tslint:enable */
